import { ViewConfiguration } from '../../../../../grid/gridView/types';
import { ColumnDetails } from '../../../../../grid/types/common';

export interface AtlassianJiraConfluenceGridViewData {
  views: Array<ViewConfiguration<any, any>>;
  allColumns: Array<ColumnDetails<any, any>>;
  defaultViewProps: ViewConfiguration<any, any>;
}

export enum Column {
  ORGANIZATION_SITE_DOMAIN,
  PRODUCT_ADMIN_EMAIL,
  JIRA,
  CONFLUENCE,
  ACTIONS,
}

export enum ColumnKeys {
  ORGANIZATION_SITE_DOMAIN = 'domain',
  PRODUCT_ADMIN_EMAIL = 'admin_email',
  JIRA = 'jira',
  CONFLUENCE = 'confluence',
  ACTIONS = 'actions',
}

export enum JiraConfluenceGridEvents {
  REMOVE_SENSOR_FROM_GRID = 'remove-sensor-from-grid',
}
